<form [formGroup]="filterForm" autocomplete="off">
  <div class="row no-gutters">
    <div class="col-12 col-lg-4 mb-4 mb-md-0">
      <py-reactive-form-input-field
        [group]="filterForm"
        [fieldName]="'searchInput'"
        [label]="'common.search_placeholder' | cxTranslate"
        [placeholder]="'users.searchForDeliveryAddress_placeholder' | cxTranslate"
        [icon]="'search'"
        [resettable]="true"
        (handleReset)="onResetSearchInput()"
        (enterEvent)="searchInputEnterPress.emit()"
      ></py-reactive-form-input-field>
    </div>
    <div class="col-12 col-lg-4 mb-4 mb-md-0">
      <div class="mx-0 mx-lg-2">
        <label class="mb-2 d-flex input-label-content" [attr.for]="'soldTosDropdown'">
          <span>{{ 'users.customerNumber_heading' | cxTranslate }}</span>
        </label>
        <py-sold-to-filter
          [controlName]="'soldTosDropdown'"
          [formGroup]="filterForm"
          [showDropdownOnAllScreenSizes]="true"
        ></py-sold-to-filter>
      </div>
    </div>
    <div *ngIf="showConnectedToPermissionDropdown" class="col-12 col-lg-4 align-self-center">
      <div class="w-100">
        <div class="mb-2">
          <py-connected-to-permission-dropdown [filterForm]="filterForm"></py-connected-to-permission-dropdown>
        </div>
      </div>
    </div>

    <div *ngIf="!showConnectedToPermissionDropdown" class="col-12 col-lg-4 align-self-center">
      <div class="d-flex justify-content-end align-items-center text-right">
        <label class="input-label-content" [htmlFor]="'showOnlyConnected'">{{
          'users.showOnlyConnected_heading' | cxTranslate
        }}</label>
        <py-reactive-form-checkbox-slider
          [group]="filterForm"
          [fieldName]="'showOnlyConnected'"
        ></py-reactive-form-checkbox-slider>
      </div>
    </div>
  </div>
</form>
